module.exports = __webpack_public_path__ + "media/zoho/zoho_faq4-3e8e701c.png";